import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-credit-auth-consent-dialog',
    templateUrl: './credit-auth-consent-dialog.component.html',
    styleUrls: ['./credit-auth-consent-dialog.component.scss'],
    standalone: false
})
export class CreditAuthConsentDialogComponent implements OnInit {

  @Input() loanId: number;
  @Input() creditAuthText: string;

  isCreditAuthChecked: boolean = false;

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {

  }

}
